












































































































































































































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { formatDateString } from "@/shared/dateString";
import {
  Employer,
  EmployerActivationRequest,
  EmployerStatusChangeRequest,
  TerminationReason
} from "@/admin/types";
import {
  FundingOption,
  EmployerSuspension,
  FeatureFlags,
  UserPermission
} from "@/shared/types";
import moment from "moment";
import { Location } from "vue-router";
import _ from "lodash";
import AddEmployerUserForm from "@/shared/components/AddEmployerUserForm.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useEmployerStore } from "@/admin/store/employer";
import { useTerminationReasonStore } from "@/admin/store/terminationReason";
import { usePartnerStore } from "@/admin/store/partner";
import { useEmployerPayrollStore } from "@/employer/store/employerPayroll";


@Component({
  components: { AddEmployerUserForm }
})
export default class EmployerGeneral extends Vue {
  @Prop() employerId: number;
  @Prop() changePartner: string;
  @Prop() routeToEmployer: (args: { changePartner?: string }) => Location;

  employerStore = useEmployerStore();
  terminationReasonStore = useTerminationReasonStore();
  partnerStore = usePartnerStore();

  employerPayrollStore = useEmployerPayrollStore();


  notifierStore = useNotifierStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();

  isSubmitDisabled = false;
  noPartnerText = "No Selling Partner";
  selectedPartner = null;
  selectedFundingOption = FundingOption.None;
  formatDateString = formatDateString;
  showReactivateEmployerModal = false;
  showConfirmTerminateModal = false;
  confirmEmployerId = null;
  reason = "";
  employerTerminationReasonId = 0;

  created (): void {
    this.employerStore.getEmployerSuspensions({ forceReload: false });
    this.onChangePartnerChanged(this.changePartner);
    this.onChangeServerPartnerId(this.serverPartnerId);
    this.terminationReasonStore.getTerminationReasons();
  }

  mounted (): void {
    this.selectedServicingPartnersUnsaved = this.selectedServicingPartners;
    this.employerPayrollStore.getPayrollDateAndCutoffDate(this.employerId);
    this.selectedFundingOption = this.employer.fundingOption;
  }

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
        ? this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit)
        : true;
  }

  get ninetyDaysInThePast (): string {
    return moment().subtract(90, "days").format("MM/DD/YYYY");
  }

  get employer (): Employer {
    const loadedEmployer = this.employerStore.employerDetail(this.employerId);
    return loadedEmployer.loaded && loadedEmployer.employer;
  }

  get nextPayrollDateFormatted (): string {
    return moment(this.employerPayrollStore.payrollDate).format("MMM DD, YYYY");
  }

  get dateTerminationScheduled (): string {
    return moment(this.employer.dateTerminationEffective).diff(moment()) >= 0 ?
        moment(this.employer.dateTerminationEffective).format("MMM DD, YYYY") :
        moment().format("MMM DD, YYYY");
  }

  get paydateLocked (): boolean {
    // if payroll date information is null, allow termination
    if (this.employerPayrollStore.payrollEditCutOffDate === null || this.employerPayrollStore.payrollDate === null) {
      return false;
    }

    const dateTimeNow = moment();
    return dateTimeNow < moment(this.employerPayrollStore.payrollDate) && dateTimeNow >=
        moment(this.employerPayrollStore.payrollEditCutOffDate);
  }

  get canTerminate (): boolean {
    if (this.employer.fundingOption === FundingOption.BendCalculatePull && this.paydateLocked) {
      return false;
    }

    return true;
  }

  get terminationProcessDate () {
    return moment(this.employer.dateTerminated).format("MMM DD, YYYY");
  }

  get terminationEffectiveDate () {
    return moment(this.employer.dateTerminationEffective).format("MMM DD, YYYY");
  }

  get suspensionsLoading () {
    return !this.employerStore.suspensionsLoaded;
  }

  get changePartnerMode () {
    return !!this.$route.query.changePartner;
  }

  get hasPartner () {
    return this.employer && this.employer.partner !== null;
  }

  get partner () {
    return this.employer && this.employer.partner;
  }

  get showActivate () {
    return this.employer.isTerminated === false
        && this.employer.isEmployerActivated === false;
  }

  get showFundingOption () {
    return this.featureFlagStore.flags.showFundingMethod === false
        || this.selectedFundingOption === FundingOption.None;
  }

  get showScheduledTermination () {
    return this.isTerminated === false && this.employer.dateTerminationEffective !== null;
  }

  get partnerOptions () {
    const mappedOptions = this.partnerStore.getPartners.map((original: any) =>
        ({ text: `${original.id} - ${original.name}`, value: original.id }));

    return mappedOptions;
  }

  get servicingPartners () {
    const options = [];
    if (!this.employer || !this.employer.servicingPartners) {
      return options;
    }

    return this.employer.servicingPartners.map(servicingPartner => ({
      text: servicingPartner.partnerName,
      value: servicingPartner.partnerId
    }));
  }

  get selectedServicingPartners () {
    if (!this.employer || !this.employer.servicingPartners) {
      return [];
    }

    return this.employer.servicingPartners
        .filter(servicingPartner => servicingPartner.isSelected)
        .map(servicingPartner => servicingPartner.partnerId);
  }

  selectedServicingPartnersUnsaved: number[] = [];

  @Watch("selectedServicingPartners")
  watchOfSelectedServicingPartners (newValue) {
    this.selectedServicingPartnersUnsaved = newValue;
  }

  onUpdateServicingPartnersClick () {
    if (this.isSubmitDisabled) {
      return;
    }
    this.isSubmitDisabled = true;
    const newServicingPartners = this.employer.servicingPartners.filter(servicingPartner =>
        _.some(this.selectedServicingPartnersUnsaved, partnerId => partnerId === servicingPartner.partnerId));

    const requestEmployer = { ...this.employerStore.employerDetail(this.employerId).employer };
    requestEmployer.servicingPartners = newServicingPartners.map(p => ({
      ...p,
      isSelected: true
    }));

    this.employerStore.updateEmployer(requestEmployer)
        .then(_ => {
          const nextRoute = this.routeToEmployer({});
          const onNavigationComplete = () => this.notifierStore.setSuccess("Partner updated");
          this.$router.push(nextRoute, onNavigationComplete);
        })
        .finally(() => this.isSubmitDisabled = false);
  }

  get serverFundingOption () {
    return this.employer && this.employer.fundingOption;
  }

  @Watch("serverFundingOption")
  onChangeFundingOption (newServerFundingOption) {
    this.selectedFundingOption = newServerFundingOption;
  }

  get serverPartnerId () {
    return this.hasPartner && this.partner && this.partner.id;
  }

  @Watch("serverPartnerId")
  onChangeServerPartnerId (newServerPartnerIdValue) {
    this.selectedPartner = newServerPartnerIdValue;
  }

  @Watch("changePartner")
  onChangePartnerChanged (isChangePartnerMode) {
    if (isChangePartnerMode) {
      this.partnerStore.reload();
    }
  }

  get isLoaded () {
    return this.employerStore.employerDetail(this.employerId).loaded;
  }

  showTerminateEmployerConfirm () {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }
          this.showConfirmTerminateModal = true;
          this.confirmEmployerId = null;
          this.reason = "";
          this.employerTerminationReasonId = 0;
        });
  }

  cancelTermination () {
    this.employerStore.cancelScheduledTermination(this.employerId);
  }

  showReactivateEmployerConfirm (): void {
    this.showReactivateEmployerModal = !this.showReactivateEmployerModal;
  }

  get showCancelScheduledTermination () {
    return moment(this.employer.dateTerminationEffective).diff(moment()) > 0 && this.employer.isTerminated === false;
  }

  onClose () {
    this.showConfirmTerminateModal = false;
    this.showReactivateEmployerModal = false;
    this.confirmEmployerId = null;
    this.reason = "";
    this.employerTerminationReasonId = 0;
    this.employer.dateTerminationEffective = null;
  }

  confirmTermination () {
    const request: EmployerStatusChangeRequest = {
      employerId: this.employerId,
      reason: this.reason,
      terminationReasonId: this.employerTerminationReasonId,
      dateTerminationEffective: this.employer.dateTerminationEffective
    };

    this.$validator.validate()
        .then(result => {
          if (result) {
            this.employerStore.terminateEmployer(request);
            this.onClose();
          }
        });
  }

  confirmReactivation () {
    const request: EmployerStatusChangeRequest = {
      employerId: this.employerId,
      reason: this.reason,
      terminationReasonId: 0,
      dateTerminationEffective: moment().format("MM/DD/YYYY")
    };

    this.$validator.validate()
        .then(result => {
          if (result) {
            this.employerStore.reactivateEmployer(request);
            this.onClose();
          }
        });
  }

  get showTerminate () {
    return this.employer.isEmployerActivated;
  }

  get isTerminationButtonDisabled () {
    return +this.confirmEmployerId !== this.employer.id
        || this.employerTerminationReasonId === 0;
  }

  get isReactivationButtonDisabled () {
    return +this.confirmEmployerId !== this.employer.id;
  }

  onUpdatePartnerClick () {
    if (this.isSubmitDisabled) return;
    this.isSubmitDisabled = true;
    const requestEmployer = { ...this.employerStore.employerDetail(this.employerId).employer };
    const originalPartnerId = requestEmployer.partner ? requestEmployer.partner.id : 0;
    requestEmployer.partner = !this.selectedPartner ? null : { id: this.selectedPartner };
    this.partnerStore.validateChosenPartner(
            { currentPartnerId: originalPartnerId, chosenPartnerId: this.selectedPartner })
        .then(() =>
            this.employerStore.updateEmployer(requestEmployer)
                .then(_ => {
                  const nextRoute = this.routeToEmployer({});
                  const onNavigationComplete = () => this.notifierStore.setSuccess("Partner updated");
                  this.$router.push(nextRoute, onNavigationComplete);
                }))
        .finally(() => this.isSubmitDisabled = false);
  }

  onReinstateClick () {
    const cancelReason = window.prompt("Are you sure you want to cancel suspension?");
    if (cancelReason) {
      const suspension: EmployerSuspension = {
        employerId: this.employerId,
        dateCreated: moment.utc().format("MM/DD/YYYY"),
        isSuspended: false,
        reason: cancelReason
      };
      this.employerStore.updateEmployerSuspension(suspension);
    }
  }

  onSuspendClick () {
    const suspendReason = window.prompt("What is the reason for suspension?", "");
    if (suspendReason) {
      const suspension: EmployerSuspension = {
        employerId: this.employerId,
        dateCreated: moment.utc().format("MM/DD/YYYY"),
        isSuspended: true,
        reason: suspendReason
      };
      this.employerStore.updateEmployerSuspension(suspension);
    }
  }

  onActivateClick () {
    const request = {
      employerId: this.employerId,
      fundingOption: this.selectedFundingOption
    };

    this.$validator.validate()
        .then(result => {
          if (result) {
            this.employerStore.activateEmployer(request);
          }
        });
  }

  get suspendedEmployer () {
    const sus = this.employerStore.suspensionForEmployerId(this.employerId);
    return sus && sus.isSuspended;
  }

  get suspendedDate () {
    const sus = this.employerStore.suspensionForEmployerId(this.employerId);
    return sus && sus.isSuspended && sus.dateCreated;
  }

  get isTerminated (): boolean {
    return this.employer.isTerminated;
  }

  fundingOptionDescription (option: FundingOption): string {
    if (option === FundingOption.BendCalculatePull) {
      return "Automated";
    } else if (option === FundingOption.ErCalculateBendPull) {
      return "File Upload";
    } else if (option === FundingOption.ErCalculateErPush) {
      return "Direct Deposit";
    } else {
      return "";
    }
  }

  get employerStatus () {
    if (this.employer.isTerminated) {
      return "Terminated";
    } else if (this.employer.isEmployerAutoActivated) {
      return "Auto-Activated";
    } else if (this.employer.isEmployerActivated) {
      return "Active";
    } else {
      return "Pending";
    }
  }

  get fundingOptionTypes () {
    return Object.keys(FundingOption)
        .filter(k => FundingOption[k] !== FundingOption.None)
        .map(k => ({ value: FundingOption[k], text: this.fundingOptionDescription(FundingOption[k]) }));
  }

}
